/**
 * This exists as a stub file just to allow developers to avoid an import like:
 *
 *  import { plansAsMsa } from './entity-reducer'
 *
 * as this doesn't make much semantic sense, instead, it is:
 *
 *  import { plansAsMsa } from './entities/bound'
 */

export * from '../entity-reducer';
